import {useRef} from 'react';
import {FormattedMessage, useIntl} from 'react-intl';
import {observer} from 'mobx-react';
import {useDrag, useDrop} from 'react-dnd';
import {ActionLink, FormError} from 'shared/components';

const Stage = observer(({stage, onStageDelete, onStageDrag, errors = {}}) => {
  const intl = useIntl();
  const containerRef = useRef(null);
  const handleRef = useRef(null);

  const [, connectDrag, connectDragPreview] = useDrag({
    type: 'stage',
    item: () => ({index: stage.order})
  });

  const [{isOver}, connectDrop] = useDrop({
    accept: 'stage',
    collect: monitor => ({isOver: monitor.isOver()}),
    hover(item) {
      const dragIndex = item.index;
      const hoverIndex = stage.order;

      if (dragIndex === hoverIndex) return;

      onStageDrag(dragIndex, hoverIndex);
      item.index = hoverIndex;
    }
  });

  connectDragPreview(connectDrop(containerRef));
  connectDrag(handleRef);

  return (
    <div className='clearfix table HoverAnimation-trigger'>
      <div className='col-11 table-cell align-middle pr1'>
        {stage.isRequired ? (<div className='p2 my2 bg-athens rounded'>
            <div className='inline-block'>{stage.name}</div>
            <div className='right waterloo'><FormattedMessage id='recruiting.edit.steps.Required'/></div>
          </div>)
        : (
          <div ref={containerRef} className={`py1 my2 bg-white border rounded clickable ${isOver ? 'is-over' : ''}`}>
            <div className='clearfix table'>
              <div className='col-11 table-cell align-middle'>
                <input value={stage.name} onChange={(e) => stage.name = e.target.value}
                       className={`border-none full-width ${isOver ? 'is-over' : ''}`}
                       style={{transition: 'none'}} type='text' placeholder={intl.formatMessage({id: 'recruiting.edit.steps.Add stage'})} />
              </div>
              <div ref={handleRef} className='col-1 table-cell align-middle right-align pr1'>
                <i className='material-symbols-solid submarine pt1'>{'drag_handle'}</i>
              </div>
            </div>
            <div className='pl1'>
              <FormError message={errors.name} />
            </div>
          </div>
        )}
      </div>
      <div className='col-1 table-cell align-middle pl1'>
        {!stage.isRequired && <div className='HoverAnimation-target--show'>
          <ActionLink onClick={() => onStageDelete(stage)} className='submarine'><i className='material-symbols-solid mx1 h2'>{'delete'}</i></ActionLink>
        </div>}
      </div>
    </div>
  );
});

export default Stage;
